import {
  GET_LEADS,
  GET_LEADS_SUCCESS,
  GET_LEADS_ERROR,
  GET_LEAD_BY_ID_SUCCESS,
  GET_LEAD_BY_ID_ERROR,
  GET_LEAD_BY_ID,
  GET_LEAD_BY_QUOTE_CALL_ID,
  GET_LEAD_BY_QUOTE_CALL_ID_SUCCESS,
  GET_LEAD_BY_QUOTE_CALL_ID_ERROR,
  UPDATE_LEAD_DETAILS,
  UPDATE_LEAD_DETAILS_SUCCESS,
  UPDATE_LEAD_DETAILS_ERROR,

  ADD_LEAD_HOME,
  ADD_LEAD_HOME_SUCCESS,
  ADD_LEAD_HOME_ERROR,
  ADD_LEAD_VIOLATION_SUCCESS,
  ADD_LEAD_VIOLATION,
  ADD_LEAD_VIOLATION_ERROR,
  ADD_LEAD_REFUND,
  ADD_LEAD_REFUND_SUCCESS,
  ADD_LEAD_REFUND_ERROR,
  DELETE_LEAD_REFUND,
  DELETE_LEAD_REFUND_ERROR,
  UPDATE_LEAD_REFUND,
  UPDATE_LEAD_REFUND_SUCCESS,
  UPDATE_LEAD_REFUND_ERROR,
  DELETE_LEAD_REFUND_SUCCESS,
  UPDATE_LEAD,
  UPDATE_LEAD_SUCCESS,
  UPDATE_LEAD_ERROR,
  GET_LEAD_DETAILS_EXPORT_SUCCESS,
  GET_LEAD_DETAILS_EXPORT_ERROR,
  GET_LEAD_DETAILS_EXPORT
} from "./actionTypes"

export const getLeads = payload => {
  return {
    type: GET_LEADS,
    payload: payload,
  }
}

export const getLeadsSuccess = (leads, meta = {}) => {
  return {
    type: GET_LEADS_SUCCESS,
    payload: leads,
    meta,
  }
}

export const getLeadsError = error => {
  return {
    type: GET_LEADS_ERROR,
    payload: error,
  }
}

export const updateLead = payload => {
  return {
    type: UPDATE_LEAD,
    payload: payload,
  }
}

export const updateLeadSuccess = lead => {
  return {
    type: UPDATE_LEAD_SUCCESS,
    payload: lead,
  }
}

export const updateLeadError = error => {
  return {
    type: UPDATE_LEAD_ERROR,
    payload: error,
  }
}

export const getLeadById = payload => {
  return {
    type: GET_LEAD_BY_ID,
    payload: payload,
  }
}

export const getLeadByIdSuccess = lead => {
  return {
    type: GET_LEAD_BY_ID_SUCCESS,
    payload: lead,
  }
}

export const getLeadByIdError = error => {
  return {
    type: GET_LEAD_BY_ID_ERROR,
    payload: error,
  }
}

export const getLeadByQuoteCallId = payload => {
  return {
    type: GET_LEAD_BY_QUOTE_CALL_ID,
    payload: payload,
  }
}

export const getLeadByQuoteCallIdSuccess = lead => {
  return {
    type: GET_LEAD_BY_QUOTE_CALL_ID_SUCCESS,
    payload: lead,
  }
}

export const getLeadByQuoteCallIdError = error => {
  return {
    type: GET_LEAD_BY_QUOTE_CALL_ID_ERROR,
    payload: error,
  }
}

//Lead Details

export const updateLeadDetails = payload => {
  return {
    type: UPDATE_LEAD_DETAILS,
    payload: payload,
  }
}

export const updateLeadDetailsSuccess = lead => {
  return {
    type: UPDATE_LEAD_DETAILS_SUCCESS,
    payload: lead,
  }
}

export const updateLeadDetailsError = error => {
  return {
    type: UPDATE_LEAD_DETAILS_ERROR,
    payload: error,
  }
}

//

//Lead Homes//

export const addLeadHome = payload => {
  return {
    type: ADD_LEAD_HOME,
    payload: payload,
  }
}

export const addLeadHomeSuccess = lead => {
  return {
    type: ADD_LEAD_HOME_SUCCESS,
    payload: lead,
  }
}

export const addLeadHomeError = error => {
  return {
    type: ADD_LEAD_HOME_ERROR,
    payload: error,
  }
}

//Lead Homes//


//Lead Violation //

export const addLeadViolation = payload => {
  return {
    type: ADD_LEAD_VIOLATION,
    payload: payload,
  }
}

export const addLeadViolationSuccess = lead => {
  return {
    type: ADD_LEAD_VIOLATION_SUCCESS,
    payload: lead,
  }
}

export const addLeadViolationError = error => {
  return {
    type: ADD_LEAD_VIOLATION_ERROR,
    payload: error,
  }
}

//Lead Violation //


//Lead Refund //

export const addLeadRefund = payload => {
  return {
    type: ADD_LEAD_REFUND,
    payload: payload,
  }
}

export const addLeadRefundSuccess = lead => {
  return {
    type: ADD_LEAD_REFUND_SUCCESS,
    payload: lead,
  }
}

export const addLeadRefundError = error => {
  return {
    type: ADD_LEAD_REFUND_ERROR,
    payload: error,
  }
}


export const deleteLeadRefund = payload => {
  return {
    type: DELETE_LEAD_REFUND,
    payload: payload,
  }
}

export const deleteLeadRefundSuccess = lead => {
  return {
    type: DELETE_LEAD_REFUND_SUCCESS,
    payload: lead,
  }
}

export const deleteLeadRefundError = error => {
  return {
    type: DELETE_LEAD_REFUND_ERROR,
    payload: error,
  }
}

export const updateLeadRefund = payload => {
  return {
    type: UPDATE_LEAD_REFUND,
    payload: payload,
  }
}

export const updateLeadRefundSuccess = lead => {
  return {
    type: UPDATE_LEAD_REFUND_SUCCESS,
    payload: lead,
  }
}

export const updateLeadRefundError = error => {
  return {
    type: UPDATE_LEAD_REFUND_ERROR,
    payload: error,
  }
}

export const getLeadDetailReport = (payload, filename) => {
  return {
    type: GET_LEAD_DETAILS_EXPORT,
    payload: payload,
    filename: filename,
  }
}

export const getLeadDetailReportSuccess = (lead, filename) => {
  return {
    type: GET_LEAD_DETAILS_EXPORT_SUCCESS,
    payload: lead,
    filename: filename,
  }
}

export const getLeadDetailReportError = error => {
  return {
    type: GET_LEAD_DETAILS_EXPORT_ERROR,
    payload: error,
  }
}